import React from 'react';

// @ts-ignore
import Icon from 'assets/images/traps/smt.svg';

interface IconProps {
  height?: number;
  width?: number;
}

const MultiCatchMouseTrapIcon: React.FC<IconProps> = ({ height = 40, width = 40 }) => {
  return <img src={Icon} alt="Multi-catch mouse trap icon" height={height} width={width} />;
};

export default MultiCatchMouseTrapIcon;
